module.exports = __webpack_public_path__ + "a3c5f2eb8a5dfc086686c5f17504dcb2.jpg";